import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 80px); /* Discount topbar */
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 16px;
    padding-bottom: 24px;
  }
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 8px;
  margin-top: 8px;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: var(--black);
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 22px;
    margin-bottom: 6px;
  }
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
  color: #424242;
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
  width: fit-content;
  
  svg {
    font-size: 16px;
    color: #757575;
  }
`;

export const AssistantGreeting = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
  margin-bottom: 24px;
  margin-top: 16px;

  @media (max-width: 768px) {
    gap: 12px;
    margin-bottom: 20px;
    margin-top: 8px;
  }
`;

export const Avatar = styled.img`
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 50%;
  box-shadow: 0px 4px 15px rgba(152, 53, 209, 0.2);
  animation: float 6s ease-in-out infinite;

  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-6px); }
    100% { transform: translateY(0px); }
  }

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
    min-width: 48px;
  }
`;

export const GreetingText = styled.h2`
  font-size: 20px;
  font-weight: 500;
  color: var(--dark-gray);
  max-width: 500px;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 17px;
  }
`;

export const QuickActionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const ActionCard = styled.button`
  background: var(--white);
  border: 1px solid rgba(0,0,0,0.04);
  border-radius: 16px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;

  @media (max-width: 768px) {
    padding: 14px 16px;
    gap: 12px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.06);
    border-color: rgba(152, 53, 209, 0.2);
  }
`;

export const IconWrapper = styled.div`
  background: var(--fixit-bg);
  color: var(--fixit);
  width: 44px;
  height: 44px;
  min-width: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    font-size: 22px;
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    min-width: 40px;
    
    svg {
      font-size: 20px;
    }
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: var(--black);

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const CardDescription = styled.p`
  font-size: 13px;
  color: var(--gray);
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const ChatSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 32px;
  position: relative;
  
  @media (max-width: 768px) {
    margin-top: 16px;
  }
`;

export const ChatBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  border-radius: 16px;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.04);
  padding: 16px;
  min-height: 160px;
  position: relative;
  cursor: not-allowed;
  z-index: 2;
  transition: all 0.3s ease;
  overflow: hidden; /* Mantém a borda cortada arredondada */

  /* Animated Thin Glow Border Effect */
  &::before {
    content: "";
    position: absolute;
    width: 200%;
    height: 200%;
    top: -50%;
    left: -50%;
    z-index: -2;
    background: conic-gradient(
      from 0deg,
      transparent 0%,
      rgba(152, 53, 209, 0.1) 60%,
      rgba(152, 53, 209, 1) 80%,
      transparent 100%
    );
    animation: rotateGlow 4s linear infinite;
    pointer-events: none;
  }

  @keyframes rotateGlow {
    100% {
      transform: rotate(360deg);
    }
  }

  /* Máscara interna para furar o meio do container e mostrar apenas a borda (1px) */
  &::after {
    content: "";
    position: absolute;
    inset: 1px; /* Espessura da borda animada */
    background: var(--white);
    border-radius: 15px; /* Ligeiramente menor que o container */
    z-index: -1;
  }

  &:hover {
    box-shadow: 0px 12px 40px rgba(152, 53, 209, 0.08);
  }

  @media (max-width: 768px) {
    min-height: 140px;
    padding: 12px;
  }
`;

export const ChatTextArea = styled.textarea`
  flex: 1;
  border: none;
  background: transparent;
  font-size: 16px;
  color: var(--dark-gray);
  resize: none;
  font-family: inherit;
  outline: none;
  cursor: not-allowed;
  pointer-events: none;
  min-height: 60px;
  margin-bottom: 12px;
  
  &::placeholder {
    color: #a0a0a0;
    font-weight: 400;
  }

  @media (max-width: 768px) {
    font-size: 15px;
    min-height: 50px;
  }
`;

export const ChatFooter = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  border-top: 1px solid var(--light-gray);
  padding-top: 16px;

  @media (max-width: 768px) {
    padding-top: 12px;
  }
`;

export const SuggestionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
  
  @media (max-width: 768px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 4px;
    -webkit-overflow-scrolling: touch;
    
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  }
`;

export const SuggestionChip = styled.button`
  background-color: rgba(152, 53, 209, 0.08);
  color: var(--fixit);
  border: 1px solid rgba(152, 53, 209, 0.2);
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: not-allowed;
  pointer-events: none;
  white-space: nowrap;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(152, 53, 209, 0.15);
  }

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 12px;
  }
`;

export const SendButton = styled.button`
  background-color: var(--fixit);
  color: var(--white);
  border: none;
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
  pointer-events: none;
  transition: opacity 0.2s ease;
  box-shadow: 0px 4px 10px rgba(152, 53, 209, 0.3);

  svg {
    font-size: 18px;
  }

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    min-width: 36px;
    
    svg {
      font-size: 16px;
    }
  }
`;
